module.exports = __webpack_public_path__ + "static/media/IOBE1.c238139a.jpg";